import { render, staticRenderFns } from "./CrmMenu.vue?vue&type=template&id=15258753&"
import script from "./CrmMenu.vue?vue&type=script&lang=js&"
export * from "./CrmMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports